//This set to use Production Mode or DevelopmentMode
export const IsProdMode = false;

export const IsEncryption = true; // false// Sanjay 22/02

export const IsQueryParamsEncryption = true; // false; // Sanjay 22/02


// AESKey for encryption and decryption
export const Value1 = process.env.REACT_APP_Value1;
//export const Value1 = 'Value1';

// AESIV for encryption and decryption
export const Value2 = process.env.REACT_APP_Value2;
//export const Value2 = 'Value2';

export const IsCookieEncryption = true;  // false  // Sanjay 22/02

// Web URL Path

export const WebURLPath = "http://localhost:3001/pageManagement/";

export const WebPath = "http://localhost:3001/";

export const GoogleMapKey = "AIzaSyCT-iv_tIKc1sINLPPiPr5RTPpFTHHI1Y0";

export const Value3 = "AuthUserA111";

export const Value4 = "TokenA111";

export const IsStagingEnvironment = false;

//export const IsUnderMaintenance = false;
